import { QuantityCounter } from '@procurify/ui'
import styled from 'styled-components'

export const ConversationOrderSummaryQuantityCounterStyled = styled(
  QuantityCounter
)`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.form.field.border};

  /* Scoped away from the focused state so the base counter's focus-within
   * pill is not overridden while the pointer rests on a focused field. */
  &:hover:not(:focus-within) {
    background-color: ${(props) =>
      props.theme.colors.button.filter.background.hover};
  }
`
